import { EAuthenticationActionType } from '../../actions/authentication';
import { EChatModalActionType } from '../../actions/chatModal';
import { IChatModal } from '../../types/chatModal';
import { TReduxActions } from '../../types/redux';

export const defaultState: IChatModal = {
  isOpen: false,
  openAfterAuth: false,
  offerId: null,
};

export function chatModalReducer(state: IChatModal = defaultState, action: TReduxActions): IChatModal {
  switch (action.type) {
    case EChatModalActionType.Open: {
      return {
        ...state,
        isOpen: true,
        defaultMessage: action.payload?.defaultMessage || undefined,
        shouldSendDefaultMessage: action.payload?.shouldSendDefaultMessage || undefined,
        dealType: action.payload?.dealType || undefined,
        offerType: action.payload?.offerType || undefined,
        gaLabel: action.payload?.gaLabel || undefined,
        offerId: action.payload?.offerId || null,
        authorId: action.payload?.authorId || undefined,
        product: action.payload?.product || undefined,
        isDotPin: action.payload?.isDotPin ?? undefined,
      };
    }

    case EChatModalActionType.Close: {
      return {
        ...state,
        isOpen: false,
        defaultMessage: undefined,
        shouldSendDefaultMessage: undefined,
        dealType: undefined,
        offerType: undefined,
        gaLabel: undefined,
        offerId: null,
        authorId: undefined,
        openAfterAuth: false,
        product: undefined,
        isDotPin: undefined,
      };
    }

    case EChatModalActionType.SetOpenAfterAuth: {
      return {
        ...state,
        isOpen: false,
        openAfterAuth: true,
        defaultMessage: action.payload?.defaultMessage || undefined,
        shouldSendDefaultMessage: action.payload?.shouldSendDefaultMessage || undefined,
        dealType: action.payload?.dealType || undefined,
        offerType: action.payload?.offerType || undefined,
        gaLabel: action.payload?.gaLabel || undefined,
        offerId: action.payload?.offerId || null,
        authorId: action.payload?.authorId || undefined,
        product: action.payload?.product || undefined,
        isDotPin: action.payload?.isDotPin ?? undefined,
      };
    }

    case EAuthenticationActionType.Succeed: {
      if (!state.openAfterAuth) {
        return state;
      }

      return {
        ...state,
        isOpen: true,
        openAfterAuth: false,
      };
    }

    case EAuthenticationActionType.Cancelled: {
      return {
        ...state,
        isOpen: false,
        openAfterAuth: false,
        defaultMessage: undefined,
        shouldSendDefaultMessage: undefined,
        dealType: undefined,
        offerType: undefined,
        gaLabel: undefined,
        offerId: null,
        authorId: undefined,
        product: undefined,
        isDotPin: undefined,
      };
    }
  }

  return state;
}
